import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-inspections-ehms.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-inspections-ehms.component.scss?ngResource";
import { Component } from "@angular/core";
let ViewApplicationInspectionsEhmsComponent = class ViewApplicationInspectionsEhmsComponent {
    constructor() { }
    ngOnInit() {
    }
    static ctorParameters = () => [];
};
ViewApplicationInspectionsEhmsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-inspections-ehms",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationInspectionsEhmsComponent);
export { ViewApplicationInspectionsEhmsComponent };
